import { render, staticRenderFns } from "./OrdersHistoryList.vue?vue&type=template&id=275fee62&scoped=true&"
import script from "./OrdersHistoryList.vue?vue&type=script&lang=js&"
export * from "./OrdersHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./OrdersHistoryList.vue?vue&type=style&index=0&id=275fee62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275fee62",
  null
  
)

export default component.exports